import carouselImg1 from 'assets/images/productPages/curlcream_carousel_1.jpg';
import carouselImg2 from 'assets/images/productPages/curlcream_carousel_2.jpg';
import carouselImg3 from 'assets/images/productPages/curlcream_carousel_3.jpg';
import formulaModuleHeroDesktop from 'assets/images/productPages/d-module_2_hero.jpg';
import acaciaCollagenImg from 'assets/images/productPages/ingredients/acacia_collagen.png';
import arganOilImg from 'assets/images/productPages/ingredients/argan_oil.png';
import arginineImg from 'assets/images/productPages/ingredients/arginine.png';
import baobabExtractImg from 'assets/images/productPages/ingredients/baobab_extract.png';
import caviarLimeExtractImg from 'assets/images/productPages/ingredients/caviar_lime_extract.png';
import coconutOilImg from 'assets/images/productPages/ingredients/coconut_oil.png';
import flaxSeedExtractImg from 'assets/images/productPages/ingredients/flax_seed_extract.png';
import hyaluronicAcidImg from 'assets/images/productPages/ingredients/hyaluronic_acid.png';
import jojobaOilImg from 'assets/images/productPages/ingredients/jojoba_oil.png';
import lilacExtractImg from 'assets/images/productPages/ingredients/lilac_extract.png';
import peaExtractImg from 'assets/images/productPages/ingredients/pea_extract.png';
import pequiOilImg from 'assets/images/productPages/ingredients/pequi_oil.png';
import sheaOilImg from 'assets/images/productPages/ingredients/shea_oil.png';
import formulaModuleHeroMobile from 'assets/images/productPages/mt-module_2_hero.jpg';

export default {
  sampleFormulasSlider: [
    {
      title: 'SHINE + HEAT PROTECTANT CURL CREAM FOR MILENE',
      ingredients: [
        {
          image: pequiOilImg,
          name: 'Pequi Oil',
          benefit: 'Anti-Frizz',
        },
        {
          image: lilacExtractImg,
          name: 'Lilac Extract',
          benefit: 'Hair Health',
        },
        {
          image: caviarLimeExtractImg,
          name: 'Caviar Lime Extract',
          benefit: 'Shine',
        },
        {
          image: arganOilImg,
          name: 'Argan Oil',
          benefit: 'Nourishment',
        },
        {
          image: arginineImg,
          name: 'Arginine',
          benefit: 'Heat Protect',
        },
        {
          image: acaciaCollagenImg,
          name: 'Acacia Collagen',
          benefit: 'Fiber Repairing',
        },
      ],
    },
    {
      title: 'NOURISHING + HYDRATING CURL CREAM FOR ERIN',
      ingredients: [
        {
          image: baobabExtractImg,
          name: 'Baobab Extract',
          benefit: 'Fiber Repairing',
        },
        {
          image: sheaOilImg,
          name: 'Shea Oil',
          benefit: 'Nourishment',
        },
        {
          image: coconutOilImg,
          name: 'Coconut Oil',
          benefit: 'UV Control',
        },
        {
          image: jojobaOilImg,
          name: 'Jojoba Oil',
          benefit: 'Nourishment',
        },
        {
          image: flaxSeedExtractImg,
          name: 'Linseed Extract',
          benefit: 'Curl Definition',
        },
        {
          image: hyaluronicAcidImg,
          name: 'Hyaluronic Acid',
          benefit: 'Hydration',
        },
      ],
    },
    {
      title: ' ANTI-FRIZZ + REPAIRING CURL CREAM FOR CHRIS',
      ingredients: [
        {
          image: flaxSeedExtractImg,
          name: 'Linseed Extract',
          benefit: 'Curl Definition',
        },
        {
          image: pequiOilImg,
          name: 'Pequi Oil',
          benefit: 'Anti-Frizz',
        },
        {
          image: acaciaCollagenImg,
          name: 'Acacia Collagen',
          benefit: 'Fiber Repairing',
        },
        {
          image: lilacExtractImg,
          name: 'Lilac Extract',
          benefit: 'Hair Health',
        },
        {
          image: peaExtractImg,
          name: 'Pea Extract',
          benefit: 'Heat Protection',
        },
        {
          image: baobabExtractImg,
          name: 'Baobab Extract',
          benefit: 'Fiber Repairing',
        },
      ],
    },
  ],
  proTips: [
    {
      background: 'blueLight',
      number: '213',
      description:
        'Apply Custom Curl Cream to dry, detangled hair prior to twist-outs, rod sets, or bantu knots. Custom Curl Cream allows for soft, lightweight hold without any dryness or flaking.',
    },
    {
      background: 'blueLight',
      number: '572',
      description:
        'To revive curls in between washes, start by lightly dampening your lengths. Apply a small amount of custom curl cream to individual curls to hydrate and de-frizz. No need to rake through—simply finish by scrunching or air-drying.',
    },
    {
      background: 'blueLight',
      number: '106',
      description:
        'Apply custom curl cream on dry, detangled lengths prior to twist-outs, rod sets or bantu knots. Custom curl cream allows for soft, lightweight hold without any dryness or flaking.',
    },
  ],
  pressQuote: {
    source: 'Approved by Michelle Breyer, Founder of NaturallyCurly.com, Author + Curl Expert',
    quote:
      'I finally found the perfect curl cream with the right amount of hold, moisture and shine — and it’s customized for me! I wish I had thought of the idea.',
  },
  faq: [
    {
      question: 'What is Curl Cream?',
      answer:
        'Prose Curl Cream is a multipurpose product that offers hydration, definition, and a bit of hold. With an airy, lotion-like texture, it smooths and defines your natural curls without compromising volume or leaving behind crunch or residue. It can be used alone or in combination with other custom styling products.',
    },
    {
      question: 'What hair textures does Prose Custom Curl Cream work for?',
      answer: `Prose Curl Cream is custom-formulated for hair textures ranging from Type 2 waves to Type 3 curls and Types 4A, 4B, and 4C coils. It defines your natural curl pattern and provides light hold for a variety of styles without a stiff finish.`,
    },
    {
      question: 'How do I customize my Curl Cream?',
      answer: (
        <>
          Creating your own Custom Curl Cream formula is as easy as 1, 2, 3:
          <br />
          1. Take our in-depth online consultation so we can understand what kind of care your hair
          needs. <br />
          2. We’ll use 85+ factors from your consultation to customize your Curl Cream to your
          hair’s unique needs. <br />
          3. Share feedback on your formula via Review and Refine® so we can provide evolving,
          always custom-fitting care.
        </>
      ),
    },
    {
      question: 'How do I use Prose Custom Curl Cream?',
      answer:
        'Custom Curl Cream can be applied to damp or dry hair to help with hair styling and minimizing unwanted frizz. Your Custom Curl Cream order will arrive with your detailed routine.',
    },
    {
      question: 'Is Prose Custom Curl Cream color-safe?',
      answer:
        'Yes — all Prose products are color-safe, and if you indicate color treatments during the consultation, your Custom Curl Cream may contain additional ingredients for color protection.',
    },
    {
      question: 'Is Prose Curl Cream curl-friendly?',
      answer:
        'All Custom Curl Cream formulas are vegan, cruelty-free, sulfate-free, paraben-free, pthalate-free, and alcohol-free. You can also opt for a silicone-free and/or fragrance-free formula during your consultation.',
    },
    {
      question: 'Is Prose Custom Curl Cream Curly Girl Method-approved?',
      answer: `Yes, our Custom Curl Cream was developed with curl experts and can be formulated to adhere to the Curly Girl Method. It does not contain any alcohol, sulfates, or parabens, and you can opt for a fragrance-free formula during your consultation. Custom Curl Cream contains water-dispersible silicone, though you can opt for silicone-free if you'd like.`,
    },
  ],
  imageCarousel: [
    {
      image: carouselImg1,
      alt: 'Single Prose custom curl cream bottle against tan background.',
    },
    {
      image: carouselImg2,
      alt: 'Single Prose custom curl cream bottle with loofah on a pedestal against white tile background.',
    },
    {
      image: carouselImg3,
      alt: 'Hand holding Prose custom curl cream bottle against pink background.',
    },
  ],
  formulaModule: {
    header: 'A Curl Cream that couldn’t exist without you',
    description:
      'We’ll formulate your Custom Curl Cream to address your unique hair needs and goals. Your formulas will be made with a custom blend of sustainably sourced, naturally powerful ingredients.',
    hero: {
      imageDesktop: formulaModuleHeroDesktop,
      imageMobile: formulaModuleHeroMobile,
      alt: 'Smiling woman with long brown curls swept across face',
    },
  },
  cleanBeautyModule: {
    description:
      'Like every product we formulate, your Curl Cream is made without parabens, sulfates, phthalates, mineral oils, or GMOs, and is always cruelty-free. Based on your preferences, we can make your formula vegan, silicone-free, or fragrance-free.',
  },
};
